import { Box, Modal, Typography, Link, Button, Divider } from "@mui/material";

interface Props {
  open: boolean;
  onClose: () => void;
}

const InfoModal = ({ open, onClose }: Props) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className="modal-container"
      sx={{ alignSelf: "center", justifySelf: "center" }}
    >
      <Box className="modal-container-box">
        <Typography variant="h3" sx={{ marginBottom: 1 }}>
          BankID
        </Typography>
        <Typography sx={{ marginBottom: 0.5 }}>
          BankID är kopplat till den dator som du laddar ner ditt BankID på.
        </Typography>
        <Typography sx={{ marginBottom: 0.5 }}>
          Du behöver ha ett uppdaterat BankID-program på datorn.
        </Typography>
        <Link
          href={
            "https://support.bankid.com/sv/fragor-svar/allmana-fragor/hur-bestaller-jag-bankid"
          }
          target="_blank"
          rel="noreferrer"
        >
          Läs om hur du kommer igång med BankID
        </Link>
        <Typography variant="h3" sx={{ marginBottom: 1, marginTop: 2 }}>
          Mobilt BankID
        </Typography>
        <Typography sx={{ marginBottom: 0.5 }}>
          Mobilt BankID laddar du ner till mobilen eller surfplattan.
        </Typography>
        <Typography sx={{ marginBottom: 0.5 }}>
          Kan användas för inloggning i flera enheter, även datorn.
        </Typography>
        <Typography sx={{ marginBottom: 0.5 }}>
          Du behöver ha en uppdaterad BankID-app i den enhet som du laddar ner
          Mobilt BankID i.
        </Typography>
        <Link
          href={"https://support.bankid.com/sv/bankid/mobilt-bankid"}
          target="_blank"
          rel="noreferrer"
        >
          Läs om hur du kommer igång med Mobilt BankID
        </Link>
        <Box className="flex-row-center-end" sx={{ marginTop: 4 }}>
          <Button className="secondary-button" onClick={onClose}>
            STÄNG
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default InfoModal;
